import * as tslib_1 from "tslib";
import './radio.less';
import m from 'mithril';
import { randomKey } from '../../util/formutils';
import { Component } from '../component';
import { classes } from '../../util/classes';
var Radio = /** @class */ (function (_super) {
    tslib_1.__extends(Radio, _super);
    function Radio() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = _this.attrs.className || (_this.attrs.unstyled && 'radio') || 'radio-front';
        _this.id = randomKey('radio_');
        return _this;
    }
    Radio.prototype.view = function () {
        var _a = this.attrs, _b = _a.value, value = _b === void 0 ? false : _b, onchange = _a.onchange, option = _a.option, _c = _a.name, name = _c === void 0 ? this.id : _c, required = _a.required, disabled = _a.disabled, rest = tslib_1.__rest(_a, ["value", "onchange", "option", "name", "required", "disabled"]);
        return m("div." + this.className, classes({ is: { disabled: disabled } }), [
            m("input." + this.className + "-input", tslib_1.__assign({ type: 'radio', checked: !!value, required: required, name: name, onclick: onchange && (function () { return onchange(!value); }), id: this.id, disabled: disabled }, rest)),
            m("label." + this.className + "-label", { for: this.id }, [
                m("span." + this.className + "-label-bullet"),
                m("span." + this.className + "-label-text", option)
            ])
        ]);
    };
    return Radio;
}(Component));
export { Radio };
